import React, { ReactElement, useRef, useState } from 'react';

import { PrismicRichText } from '@prismicio/react';
import { Element } from '@prismicio/richtext';

import { clsx } from 'clsx';
import Slider, { Settings } from 'react-slick';

import ReactPlayer from 'react-player/youtube';

import { smallScreen } from '@styles/constants';
import { ImageGallery } from '@components/organisms/ImageGallery';

import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { SliceFields } from './types';
import * as S from './styles';

interface Props {
  item: SliceFields;
}

export function SliceAccordionContent({ item }: Props): ReactElement {
  const [images, setImages] = useState([]);
  const [imagesIndex, setImagesIndex] = useState(0);
  const [show, setShow] = useState(false);
  const slider = useRef(null);

  const sliderSettings: Settings = {
    // adaptiveHeight: true,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: smallScreen,
        settings: {
          swipe: false,
        },
      },
    ],
    slidesToScroll: 1,
    slidesToShow: 1,
  };

  function showGallery(gallery: any, index: any): void {
    setImages(gallery);
    setImagesIndex(index);
    setShow(true);
  }

  function closeGallery(): void {
    setShow(false);
    // setImages([]);
  }

  const propsWithUniqueKey = (props: any, key: any): any => ({
    ...(props || {}),
    key,
  });

  const htmlSerializer = (
    type: any,
    element: any,
    contentHtml: any,
    childrenHtml: any,
    key: any
  ): any => {
    let props = {};
    switch (type) {
      // Don't wrap images in a <p> tag
      case Element.image: {
        props = {
          alt: element.alt || 'Img',
          onClick: () => {
            showGallery([{ ...element }], 0);
          },
          src: element.url,
        };
        return React.createElement(
          'div',
          { className: 'block-img' },
          React.createElement('img', propsWithUniqueKey(props, key))
        );
      }
      case Element.embed: {
        return React.createElement(
          'div',
          { className: 'block-embed' },
          <ReactPlayer
            className="react-player"
            url={element?.oembed?.embed_url}
            width="100%"
            height="100%"
          />
        );
      }
      default:
        return null;
    }
  };

  const hasRichTextContent =
    item?.rich_text_2?.some((z: any) =>
      z.type === 'image' ? Boolean(z.url) : false
    ) || false;

  const imagesByRichText = item?.rich_text_2?.filter(
    (z: any) => z.type === 'image'
  );

  return (
    <S.ContentWrapper className="list-content">
      {item.subtitle && <PrismicRichText field={item.subtitle} />}
      <div className="list-content-container">
        {item.rich_text && (
          <div
            className={clsx('list-content-col list-content-col--left', {
              'col-full-width': !hasRichTextContent,
            })}
          >
            <PrismicRichText
              field={item.rich_text}
              components={htmlSerializer}
            />
          </div>
        )}
        {hasRichTextContent && (
          <div className="list-content-col list-content-col--right">
            <Slider {...sliderSettings} ref={slider}>
              {imagesByRichText.map((slide: any, slideIndex: any) => (
                <button
                  type="button"
                  className="content__slide"
                  key={`imgSlide-${slideIndex}`}
                  onClick={() => showGallery(imagesByRichText, slideIndex)}
                >
                  <PrismicNextImage
                    field={slide}
                    width={860}
                    style={{ width: '100%', height: 'auto' }}
                    sizes="(max-width: 1278px) 100vw, 33vw"
                  />
                </button>
              ))}
            </Slider>
          </div>
        )}
      </div>
      <ImageGallery
        images={images}
        index={imagesIndex}
        show={show}
        hide={() => {
          closeGallery();
        }}
      />
    </S.ContentWrapper>
  );
}

SliceAccordionContent.componentName = 'product_details_accordion';
